import { Component, OnInit, Input, ɵConsole } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Globals } from "../../../globals";
import Swal from "sweetalert2";
import { ConflictosService } from "../../servicios/conflictos.service";
// import { AdministradorPreguntasComponent } from "../../../administrador-preguntas/administrador-preguntas.component";
import { EventoscomService } from '../../../servicios/eventoscom.service';

@Component({
  selector: "app-formulario-conflicto",
  templateUrl: "./formulario-conflicto.component.html",
  styleUrls: ["./formulario-conflicto.component.css"]
})
export class FormularioConflictoComponent implements OnInit {
  @Input() tipoPregunta: number;
  @Input() respuestaSeleccionada;
  @Input() configCampos;

  llenarFormulario;
  botonCrear;
  botonActualizar;
  botonVolver;
  conflictoSeleccionado;
  etiquetaError = {
    titulo: { es: "Ocurrió un problema!", en: "There's been a problem!" },
    mensaje: {
      es: "Por favor complete todos los campos",
      en: "Please complete all fields"
    }
  };
  etiquetaOk = {
    titulo: { es: "Conflicto creado", en: "Conflict Created" },
    mensaje: {
      es: "Se ha ingresado el conflicto correctamente",
      en: "The conflict has been entered correctly"
    }
  };
  actualizarOk = {
    titulo: { es: "Conflicto Actualizado", en: "Updated conflict" },
    mensaje: {
      es: "Se ha ingresado el conflicto correctamente",
      en: "The conflict has been entered correctly"
    }
  };

  grupoFormulario: FormGroup;
  constructor(public globals: Globals, private conflictosService: ConflictosService,private eventoscomService: EventoscomService) {}

  // constructor(public globals: Globals, private conflictosService: ConflictosService,private administradorPreguntasComponent: AdministradorPreguntasComponent) {}

  ngOnInit() {

  //////conole.log("TIPO PREGUNTAAAA ");
  //////conole.log(this.tipoPregunta);
  //////conole.log("RESPUESTA SELECCIONADA ");
  //////conole.log(this.respuestaSeleccionada);
  //////conole.log("CONFIG CAPOOOS ");
  //////conole.log(this.configCampos);

    let group = {};
    this.grupoFormulario = new FormGroup(group);
    if (this.globals.lenguaje == "es") {
      this.llenarFormulario = "A continuación diligencia los siguientes campos:";
      this.botonCrear = "Crear";
      this.botonActualizar = "Actualizar";
      this.botonVolver = "Volver";
    } else {
      this.llenarFormulario = "Then fill in the following fields:";
      this.botonCrear = "Create";
      this.botonActualizar = "Update";
      this.botonVolver = "Back";
    }
  }

  valorRes(id) {
    if (this.respuestaSeleccionada) {
      let res = this.respuestaSeleccionada[id];
     
      if (res) {
        return res["valor"];
      }
    }
    return "";
  }

  validarSelect(tipo) {
    if (tipo == "select" && this.globals.conflictosEditarConflicto) {
      return false;
    } else if (tipo == "select") {
      return true;
    } else {
      return false;
    }
  }

  validarSelectAbierto(tipo) {
    if (tipo == "selectabierto") {
      return true;
    } else if (tipo == "select" && this.globals.conflictosEditarConflicto) {
      return true;
    } else {
      return false;
    }
  }

  crear() {

    //////conole.log("LUGAR DEL CONFLICTO",this.globals.lugarConflicto)

    
    //////conole.log("Campos enviados: ", this.grupoFormulario.value);
    //////conole.log("Estado: ", this.grupoFormulario);

    if (this.grupoFormulario.status == "VALID") {
      let valores = this.grupoFormulario.value;
      valores["29"] = "SI";

      let etiquetaCargando = { es: "Cargando", en: "Loading" };
      Swal.fire(etiquetaCargando[this.globals.lenguaje]);
      Swal.showLoading();

      this.conflictosService
        .crearConflicto(this.globals.IdFuncionarioTablaFuncionarios, this.tipoPregunta, valores,this.globals.lugarConflicto)
        .subscribe(datos => {
          this.globals.listaConflictoSI.push({'idPregunta':this.tipoPregunta})
          //////conole.log(this.globals.listaConflictoSI)
          //////conole.log(datos);
          Swal.close();
          Swal.fire(
            this.etiquetaOk.titulo[this.globals.lenguaje],
            this.etiquetaOk.mensaje[this.globals.lenguaje],
            "success"
          );
          delete valores["29"];
          this.globals.ConflictosVarGlobal = "";
          this.globals.PrincipalAdministradorpreguntas = true;
          //this.globals.conflictosEditarDesdeEncuesta = false;
          //this.administradorPreguntasComponent.ConsultaCamposPregunta(this.globals.idconflictoActual);
          this.eventoscomService.sendMessage('Message from Home Component to App Component!');
          this.globals.NuevoConflicto = false;
          
          
        });
    } else {
      Swal.fire(
        this.etiquetaError.titulo[this.globals.lenguaje],
        this.etiquetaError.mensaje[this.globals.lenguaje],
        "error"
      );
    }
    
  }

  volver(){

          
          this.globals.PrincipalAdministradorpreguntas = true;
          //this.administradorPreguntasComponent.ConsultaCamposPregunta(this.globals.idconflictoActual);
          this.eventoscomService.sendMessage('Message from Home Component to App Component!');
          this.globals.NuevoConflicto = false;

          //this.globals.conflictosnuevoDesdeEncuesta = false;

          this.globals.conflictosPreguntaGlobal = false;

  }

  volveractualizar(){

    
    //this.globals.conflictosEditarDesdeEncuesta = false;

    
    this.globals.PrincipalAdministradorpreguntas = true;
    //this.administradorPreguntasComponent.ConsultaCamposPregunta(this.globals.idconflictoActual);
    this.eventoscomService.sendMessage('Message from Home Component to App Component!');
    this.globals.EditarConflicto = false;

    this.globals.conflictosPreguntaGlobal = false;
    

}

  

  actualizar() {

    ////conole.log("RESPUESTA SELECCIONADA",this.respuestaSeleccionada)
    
    let idconflictocrear;
    

    for (let Responsee in this.respuestaSeleccionada) {          
      let reponser = this.respuestaSeleccionada[Responsee]; 
      idconflictocrear = reponser.idRespuestaConflicto
    }    

      ////conole.log("IDDD CONFLICTOOOOO",idconflictocrear);
      this.conflictoSeleccionado=idconflictocrear;

     this.conflictosService
         .actualizar_registro(idconflictocrear,this.globals.IdFuncionarioTablaFuncionarios)
         .subscribe(datos => {
           ////conole.log(datos);
       });
    

    ////conole.log("Campos enviados: ", this.grupoFormulario.value);

    if (this.grupoFormulario.status == "VALID") {
      let valores = this.grupoFormulario.value;
      let listaEnvio = {};
      for (const id in valores) {
        if (valores.hasOwnProperty(id)) {
          const valor = valores[id];
          if (this.respuestaSeleccionada) {
            let res = this.respuestaSeleccionada[id];
            if (res) {
              let idRespuestaIndividual = res["idRespuestaIndividual"];
              let valorAntiguo = res["valor"];
              if (valorAntiguo != valor) {
                listaEnvio[idRespuestaIndividual] = valor;
               
              }
            } else {
              let llave = Object.keys(this.respuestaSeleccionada)[0];
              let respuestaConflicto = this.respuestaSeleccionada[llave];
              respuestaConflicto = respuestaConflicto["idRespuestaConflicto"];
              this.conflictosService.crearRespuestaIndividual(respuestaConflicto, id, valor,this.globals.lugarConflicto).subscribe(datos => {
                //////conole.log("Creacion respuesta individual",datos);
              });
            }
          }
        }
      }
      //////conole.log("LISTA ENVIO",listaEnvio);
      let etiquetaCargando = { es: "Cargando", en: "Loading" };
      Swal.fire(etiquetaCargando[this.globals.lenguaje]);
      Swal.showLoading();
      this.conflictosService.actualizarCampos(listaEnvio,this.globals.lugarConflicto,this.conflictoSeleccionado).subscribe(datos => {
        ////conole.log(datos);
        Swal.close();
        Swal.fire(
          this.actualizarOk.titulo[this.globals.lenguaje],
          this.actualizarOk.mensaje[this.globals.lenguaje],
          "success"
        );
        this.globals.ConflictosVarGlobal = "";
        this.globals.PrincipalAdministradorpreguntas = true;
        //this.globals.conflictosEditarDesdeEncuesta = false;
        //this.administradorPreguntasComponent.ConsultaCamposPregunta(this.globals.idconflictoActual);
        this.eventoscomService.sendMessage('Message from Home Component to App Component!');
        this.globals.EditarConflicto = false;
        
      });
    } else {
      Swal.fire(
        this.etiquetaError.titulo[this.globals.lenguaje],
        this.etiquetaError.mensaje[this.globals.lenguaje],
        "error"
      );
    }


  }
}
